<cipo-dialog-header [title]="driveModuleName()" fullScreen="always" />
<mat-dialog-content>
    <app-data-list-command [hidefilter]="true" (filtersToApplyChange)="searchFiles($event)">
        <div>
            <button
                [disabled]="currentFolderId() === rootFolderId || isLoading()"
                mat-icon-button
                (click)="goBack()"
                [attr.aria-label]="'a11y.common.back' | translate">
                <mat-icon aria-hidden="true">arrow_back</mat-icon>
            </button>
            <button
                mat-icon-button
                (click)="addNewFolder()"
                [attr.aria-label]="'fileExplorer.addNewFolder' | translate">
                <mat-icon aria-hidden="true">create_new_folder</mat-icon>
            </button>
            <button
                mat-icon-button
                color="primary"
                (click)="uploadFile()"
                [attr.aria-label]="'fileExplorer.upload' | translate">
                <mat-icon aria-hidden="true">upload</mat-icon>
            </button>
        </div>
        <cipo-infinite-data-list
            class="data-list"
            primaryKey="id"
            [options]="tableOptions()"
            [tableColumns]="tableColumns()"
            [tableData]="tableData()"
            [updatedRows]="updatedRows()"
            (actionSelected)="onAction($event)"
            (rowClicked)="selectRow($event)" />
    </app-data-list-command>
</mat-dialog-content>
<mat-dialog-actions>
    <div fxLayout fxLayoutGap="12px" class="cipo--width--full">
        <div fxFlex="grow" class="cipo--overflow-x--auto cipo--overflow-y--hidden">
            <!-- Can't use cipo-attachments here because it will cause a loop (cipo-attachments -> attachments-dialog -> cipo-attachments) -->
            <mat-chip-set class="attachments-chip-set single-line">
                @for (item of attachments(); track $index) {
                    <mat-chip
                        [title]="item.note || item.name"
                        [highlighted]="!!item.note"
                        (click)="chipClick(item)"
                        (removed)="removeChip(item)">
                        <img matChipAvatar [src]="item | imageSource" alt="" />
                        {{ item.name }}
                        <button
                            matChipTrailingIcon
                            (click)="$event.stopPropagation(); editChipNote(item)"
                            [attr.aria-label]="
                                (item.note ? 'a11y.fileExplorer.editNote' : 'a11y.fileExplorer.addNote')
                                    | translate: { name: item.name }
                            ">
                            <mat-icon class="material-icons-outlined" aria-hidden="true">sticky_note_2</mat-icon>
                        </button>
                        <button
                            matChipRemove
                            [attr.aria-label]="'a11y.form.removeChip' | translate: { value: item.name }">
                            <mat-icon class="material-icons-outlined" aria-hidden="true">delete</mat-icon>
                        </button>
                    </mat-chip>
                }
            </mat-chip-set>
        </div>
        <div fxFlex="none">
            <button mat-button [mat-dialog-close]="undefined">{{ "general.cancel" | translate }}</button>
            <button mat-button mat-raised-button color="primary" [disabled]="!canSave()" (click)="onSave()">
                {{ "general.save" | translate }}
            </button>
        </div>
    </div>
</mat-dialog-actions>
